const password = {
    unsupported_encryption_method: '暗号化方式 {{name}} はサポートされていません。',
    pepper_not_found: 'パスワードペッパーが見つかりません。コアの環境を確認してください。',
};
export default password;
